export default "__VITE_ASSET__CgJIN$44__"